export enum ProfileActionsEnum {
    fetchProfile = '[profile] fetchProfile',
    fetchProfileSuccess = '[profile] fetchProfileSuccess',
    updateProfile = '[profile] updateProfile',
    updateProfileAvatar = '[profile] updateProfileAvatar',
    updateProfileSuccess = '[profile] updateProfileSuccess',
    updateProfileFailed = '[profile] updateProfileFailed',
    deleteProfileAvatar = '[profile] deleteProfileAvatar',
}
